import React, { useState } from "react";
import scrollTo from 'gatsby-plugin-smoothscroll';
import { Link } from "gatsby";
import Layout from "../../components/layout";
import MainBanner from "../../components/common/templates/page-main-banner-liquid-width";
import PageIntro from "../../components/common/templates/page-intro-section";
import ThreeColSlider from "../../components/common/templates/three-column-slider";
import PageFeatureBanner from "../../components/common/templates/page-feature-banner";
import GridLayout from "../../components/common/templates/grid-layout-section";
import CTASection from "../../components/common/templates/cta-section";
import IntroColumn from "../../components/common/templates/intro-column-section";
import ProcessFlow from "../../components/common/templates/work-process-section";
import TechnologyColumn from "../../components/common/templates/technology-column";
import TechnologySlider from "../../components/common/templates/technology-slider";
import TestimonialSlider from "../../components/common/templates/testimonial-slider";
import BlockQuote from "../../components/common/templates/block-quote";
import ColumnLayout from "../../components/common/templates/column-layout";
import SuccesStories from "../../components/common/templates/success-stories";
import BlogGrid from "../../components/blogs/blog-grid";
import {
  mainBannerObj, pageIntroObj, webBlockQuoteObj, gridlayoutObj, ctaObj,
  introColumnObj, columnLayoutObj, threeColSliderObj, processFlowObj, testimonialSliderObj,
  techColumnObj, techSliderObj, pageFeatureBannerObj, succesStoriesObj,
} from '../../components/web-app-development/web-app-development-constants';
import FormSection from "../../components/common/templates/form/form-section";
import { motion, AnimatePresence } from "framer-motion";
import SEO, { webDevJSONLD } from '../../components/seo';
import { Helmet } from "react-helmet";
import StickyCTA from "../../components/common/templates/sticky-cta-section";

function WebAppDevelopmentPage({ location }) {
  const [showVerticalNav, setShowVerticleNav] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [isLoaded, setisLoaded] = useState(false);

  const handleShowMore = () => {
    setShowMore(!showMore);
  };
  let moreItems = [];
  moreItems.push(
    {
      label: "Agile Software Development",
      link: "#agile"
    },
    {
      label: "Our Expertise",
      link: "#expertise"
    },
    {
      label: "Our Clients",
      link: "#clients"
    },
    {
      label: "Say Hello",
      link: "#contact"
    });

  const verticleNav = (
    <ul className="col vertical-navigation-list text-right">
      <li>
        <Link to="/">Home</Link>
      </li>
      <li>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo('#introduction')}>Introduction</div>
      </li>
      <li>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo('#product')}>Product</div>
      </li>
      <li>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo('#build')}> What we can build </div>
      </li>
      {!showMore && <li>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={handleShowMore}>More +</div>
      </li>}
      <AnimatePresence initial={false}>
        {
          showMore &&
          <motion.section
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { height: "auto", opacity: 1, x: 0 },
              collapsed: { height: 0, opacity: 0, x: 10 }
            }}
            transition={{
              duration: 1.2,
              ease: [0.04, 0.62, 0.23, 0.98],
              staggerChildren: 0.05,
              delayChildren: 0.05,
            }}>
            {
              moreItems.map((item, key) => {
                return <motion.li key={key}
                  variants={{
                    open: { height: "auto", opacity: 1, x: 0 },
                    collapsed: { height: 0, opacity: 0, x: 10 }
                  }}
                >
                  <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo(item.link)}>{item.label}</div>
                </motion.li>;
              })
            }
            <motion.li
              //variants={{ collapsed: { x: 10 }, open: { x: 0 } }}
              transition={{ duration: 0.8, type: "spring" }}>
              <div style={{ color: "#888888", cursor: "pointer" }} onClick={handleShowMore}>Less -</div>
            </motion.li>
          </motion.section>

        }
      </AnimatePresence>
    </ul>
  );

  return (
    <div onLoad={() => { setisLoaded(true); }}>
      <Layout addBodyClass={"web-app-development transparent-header " + (showVerticalNav ? 'verticle-navigation-active' : '')}
        footerFormType="basic" verticleNav={verticleNav} footerData={{ footerText: "web" }}>
        <Helmet>
          <script type="application/ld+json">{webDevJSONLD}</script>
        </Helmet>
        <SEO description="Rapidops provides the best custom web application development services by applying cutting-edge web development frameworks and technologies in Charlotte, NC."
          meta={[{ name: "charSet", content: "utf-8" }]}
          title="Custom web application development services by Rapidops" />
        <MainBanner data={mainBannerObj} setShowVerticleNav={setShowVerticleNav} />
        <PageIntro data={pageIntroObj} id="introduction" />
        <ThreeColSlider data={threeColSliderObj} isLoaded={isLoaded} location={location.pathname} />
        {/* <PageFeatureBanner data={pageFeatureBannerObj} id="product" isLoaded={isLoaded} /> */}
        <BlockQuote data={webBlockQuoteObj} />
        <GridLayout data={gridlayoutObj} id="build" isLoaded={isLoaded} />
        <CTASection data={ctaObj} />
        {/*<ProcessFlow data={processFlowObj} id="agile" />*/}
        <IntroColumn data={introColumnObj} id="expertise" />
        <TechnologyColumn data={techColumnObj} isLoaded={isLoaded} />
        <TechnologySlider data={techSliderObj} isLoaded={isLoaded} />
        {/* <TestimonialSlider data={testimonialSliderObj} id="clients" /> */}
        <SuccesStories data={succesStoriesObj} />
        <BlogGrid tag="Web Development" isLoaded={isLoaded} servicePage={true} />
        {/* <ColumnLayout data={columnLayoutObj} id="contact" isLoaded={isLoaded} /> */}
        {/*<FormSection location={location} className="site-footer-form" />*/}
        {/* <StickyCTA /> */}
      </Layout>
    </div>
  );
}

export default WebAppDevelopmentPage;